import 'slick-carousel/slick/slick'

export default class StaffStoriesSlider {

    constructor() {

        this.settings = {
            $slider : $('.js-staff-stories-slider')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            this.settings.$slider.slick({
                autoplay: true,
                autoplaySpeed: 5000,
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                appendDots: $('.js-staff-slider-dots'),
                prevArrow: $('.js-staff-slider-previous'),
                nextArrow: $('.js-staff-slider-next'),

                responsive: [
                    {
                        breakpoint: 1400,
                        settings: {
                            arrows: false,
                        }
                    },
                ]
            });
        }

    }

};

new StaffStoriesSlider();